import React from "react";
import type {Opportunity} from "../opportunityIntelligenceDemoData";
import {ConfidenceCell, IdentifiedCell, OppTitleCell, SourceChip, StagePill} from "./OpportunityCells";

type Props = {
    rows: Opportunity[];
    showSource?: boolean;
};

/**
 * Lightweight presentational table (no filtering / pagination) used inside the
 * grouped views (By source, By pressure). Mirrors the Realization grid styling.
 */
export const PlainOpportunityTable: React.FC<Props> = ({rows, showSource = true}) => {
    const template = showSource
        ? 'minmax(260px, 2.4fr) 1.2fr 0.9fr 1fr 1fr 0.8fr'
        : 'minmax(260px, 2.6fr) 0.9fr 1fr 1fr 0.8fr';

    return (
        <div className="oi-plain-table">
            <div className="oi-pt-head" style={{gridTemplateColumns: template}}>
                <span>Opportunity</span>
                {showSource && <span>Source</span>}
                <span>Stage</span>
                <span>Confidence</span>
                <span>Owner</span>
                <span className="oi-pt-right">Identified</span>
            </div>
            {rows.map(row => (
                <div key={row.id} className="oi-pt-row" style={{gridTemplateColumns: template}}>
                    <OppTitleCell opp={row}/>
                    {showSource && <span className="oi-pt-mid"><SourceChip source={row.source}/></span>}
                    <span className="oi-pt-mid"><StagePill stage={row.stage}/></span>
                    <span className="oi-pt-mid"><ConfidenceCell confidence={row.confidence}/></span>
                    <span className="oi-pt-mid oi-pt-owner">{row.owner}</span>
                    <span className="oi-pt-mid oi-pt-right"><IdentifiedCell opp={row}/></span>
                </div>
            ))}
        </div>
    );
};
